export const MembershipValidation = (json) => {

    console.log("json", json);

    const MyPromiss = new Promise((resolve, reject) => {
        var errorJson = {};

        // Helper function to safely handle string operations
        const safeStringTrim = (value) => {
            if (value === null || value === undefined) return '';
            return typeof value === 'string' ? value.trim() : String(value).trim();
        };

        // Membership name validation
        if (!json?.name || safeStringTrim(json.name) === "") {
            Object.assign(errorJson, { name: "Membership name cannot be empty *" });
        } else if (safeStringTrim(json.name).length < 2) {
            Object.assign(errorJson, { name: "Membership name must be at least 2 characters *" });
        } else if (safeStringTrim(json.name).length > 100) {
            Object.assign(errorJson, { name: "Membership name cannot exceed 100 characters *" });
        }

        // Membership type validation
        if (!json?.membershipType || safeStringTrim(json.membershipType) === "") {
            Object.assign(errorJson, { membershipType: "Membership type must be selected *" });
        } else if (!['value_added', 'fix_discount'].includes(json.membershipType)) {
            Object.assign(errorJson, { membershipType: "Invalid membership type selected *" });
        }

        // Price validation (renamed from Special Offer Price)
        if (!json?.price || safeStringTrim(json.price) === "") {
            Object.assign(errorJson, { price: "Price cannot be empty *" });
        } else {
            const priceValue = parseFloat(json.price);
            if (isNaN(priceValue) || priceValue <= 0) {
                Object.assign(errorJson, { price: "Price must be a valid positive number *" });
            } else if (priceValue > 999999) {
                Object.assign(errorJson, { price: "Price cannot exceed 999,999 *" });
            }
        }

        // Conditional validation based on membership type
        if (json?.membershipType === 'value_added') {
            // Value Added Amount validation
            if (!json?.valueAddedAmount || safeStringTrim(json.valueAddedAmount) === "") {
                Object.assign(errorJson, { valueAddedAmount: "Value added amount cannot be empty *" });
            } else {
                const valueAddedValue = parseFloat(json.valueAddedAmount);
                if (isNaN(valueAddedValue) || valueAddedValue <= 0) {
                    Object.assign(errorJson, { valueAddedAmount: "Value added amount must be a valid positive number *" });
                } else if (valueAddedValue > 999999) {
                    Object.assign(errorJson, { valueAddedAmount: "Value added amount cannot exceed 999,999 *" });
                }
            }

            // Value added amount should be greater than price
            if (json?.price && json?.valueAddedAmount) {
                const priceValue = parseFloat(json.price);
                const valueAddedValue = parseFloat(json.valueAddedAmount);

                if (!isNaN(priceValue) && !isNaN(valueAddedValue) && valueAddedValue <= priceValue) {
                    Object.assign(errorJson, { valueAddedAmount: "Value added amount must be greater than membership price *" });
                }
            }

        } else if (json?.membershipType === 'fix_discount') {
            // Fix Discount Percentage validation
            if (!json?.fixDiscountPercentage || safeStringTrim(json.fixDiscountPercentage) === "") {
                Object.assign(errorJson, { fixDiscountPercentage: "Fix discount percentage cannot be empty *" });
            } else {
                const discountValue = parseFloat(json.fixDiscountPercentage);
                if (isNaN(discountValue) || discountValue <= 0) {
                    Object.assign(errorJson, { fixDiscountPercentage: "Fix discount percentage must be a valid positive number *" });
                } else if (discountValue > 100) {
                    Object.assign(errorJson, { fixDiscountPercentage: "Fix discount percentage cannot exceed 100% *" });
                } else if (discountValue < 1) {
                    Object.assign(errorJson, { fixDiscountPercentage: "Fix discount percentage must be at least 1% *" });
                }
            }
        }

  

        if (json?.description && safeStringTrim(json.description) !== "") {
            if (safeStringTrim(json.description).length < 10) {
                Object.assign(errorJson, { description: "Description must be at least 10 characters *" });
            } else if (safeStringTrim(json.description).length > 500) {
                Object.assign(errorJson, { description: "Description cannot exceed 500 characters *" });
            }
        }



        resolve(errorJson);
    });

    return MyPromiss;
};